const { Typography, Link, Box } = require("@mui/material");

function Copyright(props) {
  return (
    <Box {...props}>
      <Typography variant="body2" color="text.secondary" align="center">
        Contact +8562077790708 for support
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center">
        {"Copyright © "}
        <Link color="inherit" href="/">
          Winner Express
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Box>
  );
}
export default Copyright;
